import * as React from 'react';
import { Stack } from '@fluentui/react';

const VALIDATION_FAILURE_REPAIR = 1;
const REVIEW_COMMENT_REPAIR = 2;
const MERGE_CONFLICT_REPAIR = 4;

export interface RepairActionSummary {
    repairTriggers?: number | null;
    repairValidationTargetCount?: number;
    repairReviewTargetCount?: number;
}

export function getRepairActionLabels(repair: RepairActionSummary) {
    const triggers = repair.repairTriggers ?? 0;
    const labels: string[] = [];
    if ((triggers & VALIDATION_FAILURE_REPAIR) !== 0) {
        const count = repair.repairValidationTargetCount ?? 0;
        labels.push(count > 0
            ? `Fix build/test failures (${count} ${count === 1 ? 'check' : 'checks'})`
            : 'Fix build/test failures');
    }
    if ((triggers & REVIEW_COMMENT_REPAIR) !== 0) {
        const count = repair.repairReviewTargetCount ?? 0;
        labels.push(count > 0
            ? `Address review comments (${count})`
            : 'Address review comments');
    }
    if ((triggers & MERGE_CONFLICT_REPAIR) !== 0) {
        labels.push('Resolve merge conflict');
    }
    return labels;
}

export function RepairActionBadges({ repair }: { repair: RepairActionSummary }) {
    const labels = getRepairActionLabels(repair);
    if (labels.length === 0) {
        return null;
    }

    return (
        <Stack horizontal wrap tokens={{ childrenGap: 6 }}>
            {labels.map(label => (
                <span
                    key={label}
                    style={{
                        background: '#e6f2fb',
                        borderRadius: 12,
                        color: '#004578',
                        display: 'inline-block',
                        fontSize: 12,
                        fontWeight: 600,
                        padding: '4px 8px',
                    }}
                >
                    {label}
                </span>
            ))}
        </Stack>
    );
}
